<template>   
<el-dialog     :visible.sync="addVisible"     width="520px"     custom-class="public-dialog-class"     :append-to-body="true"     title="加入班级"     :close-on-click-modal="false"     :close-on-press-escape="false"     :before-close="cancel"   >     
<div class="dialog-form">       
<el-alert v-show="errorMsg.msg" class="tips" ref="alert" type="warning">         
<el-icon class="el-icon-warning">
</el-icon> {{ errorMsg.msg }}       
</el-alert>       
<el-form         :model="ruleForm"         :rules="rules"         ref="ruleForm"         label-width="70px"         class="demo-ruleForm"       >         
<el-form-item class="pr" label="班级码: " prop="activationCode">           
<el-input autoId="input_ruleForm_activationCode"             v-model="ruleForm.activationCode"             placeholder="请输入"             size="small"             class="wd320"             @change="checkCode"           > 
</el-input>         
</el-form-item>         
<el-form-item label="学号: " prop="studentId">           
<el-input autoId="input_ruleForm_studentId"             v-model="ruleForm.studentId"             :disabled="isJoinClass && !!studentId"             placeholder="请填写真实学号，一旦填写不可修改"             size="small"             maxlength="50"             class="wd320"           > 
</el-input>         
</el-form-item>         
<el-form-item label="姓名: " prop="name">           
<el-input autoId="input_ruleForm_name"             v-model="ruleForm.name"             :disabled="isJoinClass && !name.includes('无名游客')"             placeholder="请填写真实姓名，一旦填写不可修改"             size="small"             maxlength="50"             class="wd320"           > 
</el-input>         
</el-form-item>       
</el-form>     
</div>     <template #footer>       <span class="dialog-footer">         
<el-button autoId="btn_cancel" @click="cancel">取 消 
</el-button>         
<el-button autoId="btn_confirm"           :loading="loading"           :disabled="disabled"           type="primary"           @click="confirm"           >确 定 
</el-button         >       </span>     </template>   
</el-dialog> </template>

<script>
import { joinClass, verifyCollege, classHasJoint  } from "@/api/my/my.js";
/** 加入班级 */
export default {
  data() {
    return {
      addVisible: false,
      loading: false,
      ruleForm: {
        activationCode: "",
        name: "",
        studentId: "",
      },
      isJoinClass: false,
      /** 错误信息 */
      errorMsg: {},
      rules: {},
    };
  },
  computed: {
    disabled() {
      return (
        !this.ruleForm.name ||
        !this.ruleForm.activationCode ||
        !this.ruleForm.studentId ||
        ["1", "3"].includes(this.errorMsg.status)
      );
    },
    studentId() {
      return this.$store.state.user.userInfo.studentId;
    },
    name() {
      return this.$store.state.user.userInfo.realName;
    },
  },
  methods: {
    open() {
      this.addVisible = true;
      if (this.studentId) this.ruleForm.studentId = this.studentId
      if (this.name && !this.name.includes('无名游客')) this.ruleForm.name = this.name
      this.classHasJoin()
    },

    /**
     * 是否第一次加入班级
     * @returns {Promise<void>}
     */
    async classHasJoin() {
      try {
        const { hasJoint } = await classHasJoint()
        this.isJoinClass = hasJoint
      } catch (e) {
        console.log(e)
      }
    },

    /** 校验规则 */
    checkCode() {
      if (!this.ruleForm.activationCode) {
        this.$refs.alert.visible = false;
        return;
      }
      verifyCollege({ activationCode: this.ruleForm.activationCode }).then(
        (res) => {
          if (res.data.status !== "0") {
            console.log(res.data);
            this.errorMsg = res.data;
            this.$refs.alert.visible = true;
            return;
          }
          this.errorMsg = {};
        }
      );
    },
    cancel() {
      this.$emit("cancel");
      this.clear();
    },
    clear() {
      this.addVisible = false;
      this.errorMsg = {};
      this.resetForm("ruleForm");
    },
    confirm() {
      this.loading = true;
      // joinClass(this.ruleForm).then((res) => {})
      joinClass(this.ruleForm).then((res) => {
        if (res && res.code === 200) {
          this.$store.dispatch('GetInfo')
          this.$emit("confirm", res.data);
          this.clear();
        }
      }).finally(() => {
        this.loading = false;
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-form {
  position: relative;
  padding: 28px 36px 38px;
  .form-font {
    color: #b9becc;
    font-size: 12px;
    font-weight: 400;
  }
}
.wd320 {
  width: 320px;
}
.wd180 {
  width: 180px;
}
.el-form-item {
  margin-bottom: 16px;
}
:deep(.el-dialog__header) {
  border-bottom: 1px solid var(--lineColor);
  .el-dialog__title {
    color: #3e4d71;
    font-size: 16px;
  }
  .el-dialog__headerbtn {
    font-size: 24px;
    color: #3e4d71;
  }
}
:deep(.el-dialog__body) {
  padding: 0;
}
.tips {
  margin-top: -14px;
  margin-bottom: 10px;
  i {
    vertical-align: sub;
    font-size: 20px;
  }
}
:deep(.el-alert .el-alert__description) {
  margin-top: 0;
}
</style>
